/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_FeaturedInputs */

const id_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggulan`)
};

const ms_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilihan`)
};

const da_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremhævet`)
};

const de_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgestellt`)
};

const en_us2_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured`)
};

const es_es2_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacado`)
};

const es_mx2_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacado`)
};

const fil_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itinatampok`)
};

const fr_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En vedette`)
};

const it_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In evidenza`)
};

const hu_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiemelt`)
};

const nl_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgelicht`)
};

const no_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremhevet`)
};

const pl_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyróżnione`)
};

const pt_br2_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apresentou`)
};

const pt_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em destaque`)
};

const ro_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezentat`)
};

const fi_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esitelty`)
};

const sv_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utvald`)
};

const vi_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nổi bật`)
};

const tr_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öne Çıkan`)
};

const cs_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejlepší`)
};

const bg_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Препоръчано`)
};

const ru_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендуемое`)
};

const uk_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендована`)
};

const ar_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مميز`)
};

const hi_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ीचर्ड`)
};

const th_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เด่น`)
};

const ja_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注目`)
};

const zh_cn2_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选`)
};

const zh_hant1_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精選`)
};

const ko_profile_library_featured = /** @type {(inputs: Profile_Library_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추천`)
};

/**
* | output |
* | --- |
* | "Featured" |
*
* @param {Profile_Library_FeaturedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_featured = /** @type {((inputs?: Profile_Library_FeaturedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_FeaturedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_featured(inputs)
	if (locale === "ms") return ms_profile_library_featured(inputs)
	if (locale === "da") return da_profile_library_featured(inputs)
	if (locale === "de") return de_profile_library_featured(inputs)
	if (locale === "en-US") return en_us2_profile_library_featured(inputs)
	if (locale === "es-ES") return es_es2_profile_library_featured(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_featured(inputs)
	if (locale === "fil") return fil_profile_library_featured(inputs)
	if (locale === "fr") return fr_profile_library_featured(inputs)
	if (locale === "it") return it_profile_library_featured(inputs)
	if (locale === "hu") return hu_profile_library_featured(inputs)
	if (locale === "nl") return nl_profile_library_featured(inputs)
	if (locale === "no") return no_profile_library_featured(inputs)
	if (locale === "pl") return pl_profile_library_featured(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_featured(inputs)
	if (locale === "pt") return pt_profile_library_featured(inputs)
	if (locale === "ro") return ro_profile_library_featured(inputs)
	if (locale === "fi") return fi_profile_library_featured(inputs)
	if (locale === "sv") return sv_profile_library_featured(inputs)
	if (locale === "vi") return vi_profile_library_featured(inputs)
	if (locale === "tr") return tr_profile_library_featured(inputs)
	if (locale === "cs") return cs_profile_library_featured(inputs)
	if (locale === "bg") return bg_profile_library_featured(inputs)
	if (locale === "ru") return ru_profile_library_featured(inputs)
	if (locale === "uk") return uk_profile_library_featured(inputs)
	if (locale === "ar") return ar_profile_library_featured(inputs)
	if (locale === "hi") return hi_profile_library_featured(inputs)
	if (locale === "th") return th_profile_library_featured(inputs)
	if (locale === "ja") return ja_profile_library_featured(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_featured(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_featured(inputs)
	return ko_profile_library_featured(inputs)
});
export { profile_library_featured as "profile.library.featured" }